// extracted by mini-css-extract-plugin
export default {"container":"Notification_container__OcDkW","actor":"Notification_actor__6jtFi","details":"Notification_details__FVHxu","notificationLink":"Notification_notificationLink__lPN27"};